module.exports = __webpack_public_path__ + "img/freespin2_multiplier3.51adbe61.png";